import type { FaireProductEntity } from "../../entity_types/product";

export const p_h6tj8guhjc: FaireProductEntity = {
  token: "p_h6tj8guhjc",
  type: "product",
  name: "Peanut Butter Chocolate Fudge",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/ec3280092fc984d2acb47dd3718fe885d7ca4a9542b651e470b021c87ddc66cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ad460bafd42e64cdbd14b6cc9c77e10a17142ba0f4a65e262e59e6c4a8b3544.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "Peanut Butter Chocolate Fudge is the flavor combination that is popular everywhere, anytime! We don’t layer the two flavors on top of each other but mix them completely together so you’ll enjoy both with every bite. Be aware, however, that very hot weather (above 85 degrees) can release the peanut butter oils causing a harmless but not-so nice looking white film on the top. Regardless, it still tastes phenomenal. FREE SHIPPING on all orders over $55. \n\nPeanut Butter Chocolate Fudge in a 1/2 pound resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:36.528Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
